<div class="component-viewer">
    <mat-card>
        <mat-card-header>
            <div class="mx-2 gt-table-filters">
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>From Date</mat-label>
                    <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filter.fromDate"
                        (dateChange)="getBookings()">
                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>To Date</mat-label>
                    <input matInput [matDatepicker]="toPicker" [(ngModel)]="filter.toDate" (dateChange)="getBookings()">
                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>Payment Status</mat-label>
                    <mat-select [(ngModel)]="filter.hasPaid" (selectionChange)="getBookings()">
                        <mat-option [value]="null">All</mat-option>
                        <mat-option [value]="true">Paid</mat-option>
                        <mat-option [value]="false">Unpaid</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="bookings" (filterChanged)="getBookings()" (filterReset)="resetFilter()"
                [placeholder]="'Confirmation Number or Customer Name'">
            </gt-table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="bookings" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="customerName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="customerName"> Customer Name </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.customerName}} </td>
                </ng-container>
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Email </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.email}} </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="startTime"> Date </th>
                    <td mat-cell *matCellDef="let booking"> {{formatInUserTimezone(booking.startTime, 'MM/DD/YYYY')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="timeslot">
                    <th mat-header-cell *matHeaderCellDef> Time Slot </th>
                    <td mat-cell *matCellDef="let booking">
                        {{formatInUserTimezone(booking.startTime, 'h:mm A')}} -
                        {{formatInUserTimezone(booking.endTime, 'h:mm A')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let booking">
                        <ng-container *ngIf="booking.status === BookingStatus.Booked">Booked</ng-container>
                        <ng-container *ngIf="booking.status === BookingStatus.Cancelled">Cancelled</ng-container>
                        <ng-container *ngIf="booking.status === BookingStatus.ClosedMaintenance">Closed/Maintenance</ng-container>
                        <ng-container *ngIf="booking.status === BookingStatus.Scheduled">Scheduled</ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="confirmationNumber">
                    <th mat-header-cell *matHeaderCellDef> Confirmation Number </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.confirmationNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="hasPaid">
                    <th mat-header-cell *matHeaderCellDef> Paid</th>
                    <td mat-cell *matCellDef="let booking">
                        <true-false
                            *ngIf="booking.hasPaid && (booking.refundAmount === 0 || booking.refundAmount === null)"
                            [value]="booking.hasPaid" [trueMatIcon]="'paid'" [trueText]="'Yes'"></true-false>
                        <true-false
                            *ngIf="!booking.hasPaid && (booking.refundAmount === 0 || booking.refundAmount === null)"
                            [value]="booking.hasPaid" [falseMatIcon]="'error_outline'" [falseText]="'No'"></true-false>
                        <ng-container *ngIf="booking.refundAmount > 0 && booking.totalPrice === 0">
                            <div class="gt-orange refund-status">Refunded
                                <mat-icon>currency_exchange</mat-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="booking.refundAmount > 0 && booking.totalPrice > 0">
                            <div class="gt-orange refund-status">Partial Refunded
                                <mat-icon class="refund-icon">currency_exchange</mat-icon>
                            </div>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalPrice">
                    <th mat-header-cell *matHeaderCellDef> Total Price </th>
                    <td mat-cell *matCellDef="let booking">
                        <span *ngIf="booking.priceOverride">
                            <mat-icon matTooltip="Price Override" class="override-icon">perm_identity</mat-icon>
                            {{booking.priceOverride | currency}}
                        </span>
                        <span *ngIf="!booking.priceOverride">
                            {{booking.totalPrice | currency}}
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let booking">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item *ngIf="booking.status !== BookingStatus.Cancelled && booking.hasPaid && booking.stripePaymentIntentId"
                                (click)="refund(booking)">
                                Refund <mat-icon>currency_exchange</mat-icon>
                            </button>
                            <button mat-menu-item (click)="openQuickview(booking)">
                                <mat-icon>visibility</mat-icon>
                                <span>Quick View</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>